<template>
    <layout-gestao>
        <div class="row">
            <div class="col-sm-12">
                <table-data
                    :route="url.getList"
                    :settings="table.settings"
                    :columns="table.columns"
                    :inlineFilters="table.filters"
                    :autoUpdateFilter="table.autoUpdateFilter"
                    :addParamsToUrl="table.addParamsToUrl"
                    :loadingMsg="table.loadingMsg"
                    :noDataMsg="table.notFoundMsg"
                    :orderByTemplate="table.orderByTemplate"
                    tableClass="table-responsive-sm"
                    @error-load="showError"
                >
                    <template v-slot:filters="{ tableFilters, search }">
                        <form autocomplete="false" @submit.prevent="" @keyup.enter="search">
                            <div class="row header">
                                <div class="col-12">
                                    <header-list
                                        :title="pageTitle"
                                        :placeholderSearch="searchPlaceholder"
                                        v-model="tableFilters.q"
                                        :routeAddName="`${moduleCode}.${pageID}.create`"
                                        :canAdd="canAdd"
                                        :addTitle="addTitle">
                                    </header-list>
                                </div>
                            </div>
                        </form>
                    </template>

                    <template v-slot:body="{row, index, remove}">
                        <td :class="table.columns[0].class">
                            {{ columnValue(row, table.columns[0]) }}
                        </td>
                        <td :class="table.columns[1].class">
                            {{ columnValue(row, table.columns[1]) }}
                        </td>
                        <td :class="table.columns[2].class" v-text="$t(`global.${columnValue(row, table.columns[2])}`)"></td>
                        <td :class="table.columns[3].class" v-text="$t(`global.${columnValue(row, table.columns[3])}`)"></td>
                        <!-- <td :class="table.columns[4].class" v-bind:style="{color: columnValue(row, table.columns[4])}">
                            {{ columnValue(row, table.columns[4]) }}
                        </td> -->
                        <td :class="table.columns[4].class">
                            <img height="20px" v-if="columnValue(row, table.columns[4])" :src="columnValue(row, table.columns[4])" alt="">
                        </td>
                        <column-actions v-if="checkActions"
                            :routeEdit="`${moduleCode}.${pageID}.show`"
                            @delete="deleteItem"
                            :canDetail="canDetail"
                            :canEdit="canEdit"
                            :canDelete="canDelete"
                            :row="row"
                            :index="index"
                            :callbackDelete="remove" />
                    </template>
                </table-data>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
    import mixin from '../../mixin'

    export default {
        mixins: [mixin],
        data() {
            const pageID = 'statuses';
            return {
                pageID: pageID,
                table: {
                    settings: {
                        order_by: 'order',
                        sort: 'asc',
                    },
                    columns: [
                        {
                            label: this.$t(`${pageID}.list.order`),
                            field:  'order',
                            sortable: true,
                        },
                        {
                            label: this.$t(`${pageID}.list.name`),
                            field:  'name',
                            sortable: true,
                            class: '',
                        },
                        {
                            label: this.$t(`${pageID}.list.first_process`),
                            field: 'first_process',
                            sortable: true,
                            class: 'd-none d-lg-table-cell',
                        },
                        {
                            label: this.$t(`${pageID}.list.last_process`),
                            field: 'last_process',
                            sortable: true,
                            class: 'd-none d-lg-table-cell',
                        },
                        // {
                        //     label: this.$t(`${pageID}.list.color`),
                        //     field: 'color',
                        //     sortable: false,
                        //     class: 'd-none d-lg-table-cell',
                        // },
                        {
                            label: this.$t(`${pageID}.list.image`),
                            field: 'mark',
                            class: 'text-center',
                            sortable: false,
                        },
                        {
                            label: '',
                            field:  null,
                            sortable: false,
                            class: 'actions',
                        }
                    ],
                },
              }
        },
        methods: {
        }
      }
</script>

<style scoped lang="scss">
</style>
